<template>
   <v-container fluid>
    <v-toolbar flat color="white" class="elevation-1">
      <v-toolbar-title>{{ this.$route.meta.title }}</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <div class="flex-grow-1"></div>

      <v-btn
      color="info"
      dark
      class="mb-2"
      v-if="selectDespachos.length > 0"
      @click="consolidarPlanificacion()"
    >
      <v-icon small>mdi-plus</v-icon>
      <v-divider class="mx-4" inset vertical></v-divider>
      Consolidar
    </v-btn>
    </v-toolbar>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <v-text-field
        v-model="search"
        append-icon="mdi-database-search"
        label="Buscar"
      >
      </v-text-field>

      <v-data-table
        v-model="selectDespachos"
        :headers="headers"
        :items="entrys"
        :loading="loading"
        show-select
        class="elevation-1"
        no-data-text="No se encuentran Despachos Planificados"
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-page-first',
          lastIcon: 'mdi-page-last',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
        }"
      >
      </v-data-table>
      </v-col>
    </v-row>

    <consolidadoModal
      v-if="selectDespachos.length > 0"
      ref="consolidado_modal"
      :despachos="selectDespachos"
    ></consolidadoModal>
   </v-container>
</template>
<script>
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex"
  import messageMixin from "@/mixins/common"
  import consolidadoModal from "@/components/planificardespacho/ConsolidadoModal"

  export default {
    name: "despachos",
    mixins: [messageMixin],

    components: {
      consolidadoModal
    },

    data() {
      return {
        selectDespachos: [],
        headers: [
          {
            text: "# DESPACHOS",
            value: "id",
            align: "center",
          },
          {
            text: "# PEDIDOS",
            value: "dts_pedido",
            align: "center",
          },
          {
            text: "FECHA DESPACHO",
            value: "fecha_despacho",
            align: "center",
          },
          {
            text: "TELÉFONO",
            value: "telefono_responsable",
            align: "center",
          },
          {
            text: "RESPONSABLE",
            value: "responsable",
            align: "center",
          },

        ],

        loading: true,
        search: "",
      }
    },
    computed: {
    ...mapState("PlanificarDespacho", ["entrys"]),
   
  },

    methods: {
      ...mapActions("PlanificarDespacho", ["getEntrys",]),

      consolidarPlanificacion() {
        this.$refs.consolidado_modal.showDialog = true
      }
    },

    async mounted() {
      await this.getEntrys().then(() => {
        this.loading = false
      });
    }
  }
</script>